// Safari requires a user gesture to open the software keyboard. Keep an input
// focused across React Router's deferred render, then hand focus to the field.
export function navigateWithInputFocus(navigate, path, inputId) {
  const bridge = document.createElement('input');
  bridge.type = 'tel';
  bridge.tabIndex = -1;
  bridge.setAttribute('aria-label', 'Opening verification input');
  Object.assign(bridge.style, {
    position: 'fixed', top: '0', left: '0', width: '1px', height: '1px',
    opacity: '0', fontSize: '16px', pointerEvents: 'none',
  });
  document.body.appendChild(bridge);
  bridge.focus({ preventScroll: true });

  let timeout;
  const cleanup = () => {
    observer.disconnect();
    window.clearTimeout(timeout);
    bridge.remove();
  };
  const transferFocus = () => {
    const input = document.getElementById(inputId);
    if (!input) return;
    if (!input.disabled) input.focus({ preventScroll: true });
    cleanup();
  };
  const observer = new MutationObserver(transferFocus);
  observer.observe(document.body, { childList: true, subtree: true });
  timeout = window.setTimeout(cleanup, 2000);
  try {
    navigate(path);
    transferFocus();
  } catch (error) {
    cleanup();
    throw error;
  }
}
